const content = {
  'notifications.heading.title': 'Notifications',
};

export default content;
